var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHideIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.76094 14.3667C9.18594 13.7927 8.83594 13.0127 8.83594 12.1377C8.83594 10.3847 10.2479 8.97168 11.9999 8.97168C12.8669 8.97168 13.6649 9.32268 14.2299 9.89668",
    stroke: "#667085",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1054 12.6987C14.8734 13.9887 13.8574 15.0067 12.5684 15.2407",
    stroke: "#667085",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.655 17.472C5.068 16.226 3.724 14.406 2.75 12.137C3.734 9.85798 5.087 8.02798 6.684 6.77198C8.271 5.51598 10.102 4.83398 12 4.83398C13.909 4.83398 15.739 5.52598 17.336 6.79098",
    stroke: "#667085",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4478 8.99072C20.1358 9.90472 20.7408 10.9597 21.2498 12.1367C19.2828 16.6937 15.8068 19.4387 11.9998 19.4387C11.1368 19.4387 10.2858 19.2987 9.46777 19.0257",
    stroke: "#667085",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8873 4.24951L4.11328 20.0235",
    stroke: "#667085",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHideIcon);
export default __webpack_public_path__ + "static/media/Hide-Icon.0752f5422cbea8e3bc988276d0fb4f1e.svg";
export { ForwardRef as ReactComponent };